import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import MaterialTable from 'material-table';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash';
import { CSVLink } from 'react-csv';

import UserInteractionProfile from '../UserInteractionProfile';

const styles = theme => ({
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
  },
  tableContainer: {
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  paperGraph: {
    color: theme.palette.text.secondary,
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  entriesDataTitle: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesStartedValue: {
    color: '#FF3B00',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  filteredEntriesValue: {
    color: '#FF8900',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesCompletedValue: {
    color: '#00BC2B',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesDataSubValue: {
    color: '#000000',
    fontSize: 18,
    marginLeft: 15,
  },
});

class BracketAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userProfileDialog: true,
      userData: null,
    };
  }

  closeUserProfileDialog = event => {
    this.setState({
      userProfileDialog: false,
      userData: null,
    });
  };

  openUserProfileDialog = rowData => {
    this.setState({
      userProfileDialog: true,
      userData: rowData,
    });
  };

  exportCSV = () => {
    const query = _.get(this.props, 'tableRef.current.state.query', null);
    let filter = [];

    if (query) {
      filter = query.filters.map(filter => {
        return {
          field: filter.column.field,
          value: filter.value,
        };
      });
    }

    this.props.getBracketAnalytics(this.props.interaction._id, filter).then(data => {
      const gridSize = _.get(this.props.interaction, 'params.gridSize', 0);

      const users = data.bracketData.map(user => {
        let name = 'Anonymous user';

        if (user.name) {
          name = user.name;
        } else if (user.phone) {
          name = user.phone;
        }

        const games = {};

        for (let i = 1; i <= gridSize - 1; i++) {
          const answer = _.get(user, `games.${i}.answerName`, null);
          games['G' + i] = answer;
        }

        return {
          user: name,
          phone: user.phone,
          ...games,
        };
      });
      this.props.setDataReport(users);
      this.csvLink.link.click();
    });
  };

  render() {
    let {
      classes,
      interaction,
      entriesStarted,
      entriesCompleted,
      entriesCompletedPercentage,
      filteredEntries,
      filteredEntriesPercentage,
    } = this.props;

    const pageSize = 5; //bracketData.length > 5 ? 5 : bracketData.length;

    this.columns = [
      {
        title: 'User',
        field: 'name',
        render: rowData => {
          const name = rowData.name ? rowData.name : 'Anonymous user';
          return (
            <div className={classes.displayName}>
              <Avatar className={classes.avatar} src={rowData.profile_pic}>
                <PersonOutlineOutlinedIcon />
              </Avatar>
              {name}
            </div>
          );
        },
      },
      { title: 'Phone', field: 'phone', filtering: false },
    ];
    const generalColumn = this.columns.concat(this.props.columnMaterialTable);

    return (
      <React.Fragment>
        <Paper className={classes.paper} elevation={0}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.subtitle} variant="subtitle1" gutterBottom>
                {interaction.name}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              Date range
            </Grid>
            <Grid item xs={3}>
              <div className={classes.entriesStartedValue}>{entriesStarted}</div>
              <div className={classes.entriesDataTitle}>Entries started</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.filteredEntriesValue}>
                {filteredEntries}
                <span className={classes.entriesDataSubValue}>
                  {filteredEntriesPercentage}%
                </span>
              </div>
              <div className={classes.entriesDataTitle}>Filtered entries</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.entriesCompletedValue}>
                {entriesCompleted}
                <span className={classes.entriesDataSubValue}>
                  {entriesCompletedPercentage}%
                </span>
              </div>
              <div className={classes.entriesDataTitle}>Entries completed</div>
            </Grid>
          </Grid>
        </Paper>
        <div className={classes.tableContainer}>
          <CSVLink
            data={this.props.dataReport}
            filename="data.csv"
            className="hidden"
            ref={r => (this.csvLink = r)}
            target="_blank"
          />
          <MaterialTable
            elevation={0}
            key={pageSize}
            tableRef={this.props.tableRef}
            options={{
              pageSize: pageSize,
              filtering: true,
              toolbar: true,
              paging: true,
              exportButton: true,
              exportCsv: () => {
                this.exportCSV();
              },
            }}
            columns={generalColumn}
            data={query =>
              new Promise((resolve, reject) => {
                const per_page = 5;
                const page = query.page + 1;
                const filter = query.filters.map(filter => {
                  return {
                    field: filter.column.field,
                    value: filter.value,
                  };
                });
                this.props
                  .getBracketAnalytics(this.props.interaction._id, filter, per_page, page)
                  .then(data => {
                    resolve({
                      data: data.bracketData,
                      page: data.page - 1,
                      totalCount: data.total,
                    });
                  });
              })
            }
            title="Users"
            onRowClick={(event, rowData) => this.openUserProfileDialog(rowData)}
          />
          {this.state.userData && (
            <UserInteractionProfile
              userData={this.state.userData}
              open={this.state.userProfileDialog}
              onClose={this.closeUserProfileDialog}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BracketAnalytics);
